/* DELIBERATELY OFF-SYSTEM COLOURS.
   This is a development-only overlay for switching mock users. Every other
   component in the app reads design tokens; this one hardcodes a cool grey so
   it can never be mistaken for real product chrome, and so it stays visually
   foreign after the Academic (parchment) rebrand. It is excluded from the
   "no literal hex" rule in handoff-academic/CLAUDE.md 6 on purpose.
   It does not render in production builds. */
/* eslint-disable */
/**
 * Dev-only role switcher — renders ONLY when the mock backend is active.
 *
 * Lets you jump between Admin / Chair / Reviewer / Author without a login
 * round-trip, so every role-gated screen is reachable while designing.
 * Never mounts in production: App.jsx guards on isMockMode, which is false in
 * any production build.
 */
import React, { useState } from 'react';
import { isMockMode } from '../../lib/supabase';
import { switchMockUser } from '../../lib/mock/mockSupabase';
import { CURRENT_USER_IDS } from '../../lib/mock/seed';

const ROLES = [
  { key: 'admin', label: 'Admin', hint: 'Amine Belkacem — organizer + chair + reviewer' },
  { key: 'chair', label: 'Chair', hint: 'Nadia Cherif — chair + reviewer' },
  { key: 'reviewer', label: 'Reviewer', hint: 'Karim Haddad — reviewer + author' },
  { key: 'author', label: 'Author', hint: 'Sofia Mansouri — author' },
];

export default function MockUserSwitcher() {
  if (!isMockMode) return null;

  const [open, setOpen] = useState(false);
  const [active, setActive] = useState(() => {
    try {
      const id = localStorage.getItem('cmp:mockuser:v1');
      return ROLES.find((r) => CURRENT_USER_IDS[r.key] === id)?.key || 'admin';
    } catch (_) {
      return 'admin';
    }
  });

  const pick = (key) => {
    setActive(key);
    switchMockUser(CURRENT_USER_IDS[key]);
  };

  return (
    <div
      style={{
        position: 'fixed',
        // Lanes for the three fixed overlays: consent card owns bottom-end,
        // toasts stack above this switcher on bottom-start.
        left: 16,
        bottom: 16,
        zIndex: 2147483000,
        fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
        fontSize: 12,
      }}
    >
      {open && (
        <div
          style={{
            marginBottom: 8,
            background: '#11141a',
            border: '1px solid #2a2f3a',
            borderRadius: 8,
            padding: 6,
            minWidth: 210,
            boxShadow: '0 8px 24px rgba(0,0,0,.45)',
          }}
        >
          <div style={{ color: '#6b7280', padding: '4px 8px 6px' }}>MOCK DATA — not production</div>
          {ROLES.map((r) => (
            <button
              key={r.key}
              onClick={() => pick(r.key)}
              title={r.hint}
              style={{
                display: 'block',
                width: '100%',
                textAlign: 'left',
                padding: '6px 8px',
                borderRadius: 6,
                border: 'none',
                cursor: 'pointer',
                background: active === r.key ? '#1f2937' : 'transparent',
                color: active === r.key ? '#f9fafb' : '#9ca3af',
              }}
            >
              {r.label}
            </button>
          ))}
          <button
            onClick={() => window.__mock?.reset()}
            style={{
              display: 'block',
              width: '100%',
              textAlign: 'left',
              padding: '6px 8px',
              marginTop: 4,
              borderTop: '1px solid #2a2f3a',
              background: 'transparent',
              border: 'none',
              color: '#9ca3af',
              cursor: 'pointer',
            }}
          >
            Reset data
          </button>
        </div>
      )}

      <button
        onClick={() => setOpen((o) => !o)}
        style={{
          background: '#11141a',
          color: '#e5e7eb',
          border: '1px solid #2a2f3a',
          borderRadius: 999,
          padding: '6px 12px',
          cursor: 'pointer',
          boxShadow: '0 4px 12px rgba(0,0,0,.4)',
        }}
      >
        <span style={{ color: '#f59e0b' }}>●</span> mock · {active}
      </button>
    </div>
  );
}
